import { IInquiryResponse, TInquiryStatus } from '@interfaces/inquiries';
import {
  ISupplementResponse,
  ISupplementResponseDetails,
  TSupplementResponseStatus,
} from '@interfaces/supplements';

const updateSupplementStatusToComplete = (supplement: ISupplementResponse) => ({
  ...supplement,
  supplementInquiryStatusId: TSupplementResponseStatus.Complete,
});

const hasNoMoreIncompleteSupplements = (supplements: ISupplementResponse[]) =>
  supplements.every(item => item.supplementInquiryStatusId === TSupplementResponseStatus.Complete);

export const updateInquiryStatusAndListItemStatusToComplete = (
  inquiryResponse: IInquiryResponse,
  activeSupplementId: number,
) => {
  const newSupplements = inquiryResponse.supplementInquiriesDto.map(supplement =>
    supplement.supplementInquiryId === activeSupplementId
      ? updateSupplementStatusToComplete(supplement)
      : supplement,
  );

  const newStatus = hasNoMoreIncompleteSupplements(newSupplements)
    ? TInquiryStatus.Complete
    : inquiryResponse.inquiryStatusId;

  return {
    ...inquiryResponse,
    inquiryStatusId: newStatus,
    supplementInquiriesDto: newSupplements,
  };
};

export const updateActiveSupplementStatusToComplete = (
  activeSupplementData: ISupplementResponseDetails,
) => ({
  ...activeSupplementData,
  supplementInquiryStatusId: TSupplementResponseStatus.Complete,
});
